import NormalLayout from 'components/Layouts/NormalLayout'
import { useNavigate } from 'react-router-dom'
import { QrcodeIcon, ArrowDownIcon } from '@heroicons/react/outline'

const PayOrReceive = () => {
  const navigate = useNavigate()

  return (
    <NormalLayout>
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="heading-2 mb-2">Send or Receive</h1>
          <p className="text-neutral-500">Choose how you'd like to transfer money</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <button
            onClick={() => navigate('/payment/pay-with-qr')}
            className="card card-hover p-8 text-center group"
          >
            <div className="w-16 h-16 rounded-2xl bg-secondary-100 flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
              <QrcodeIcon className="w-8 h-8 text-secondary-600" />
            </div>
            <h3 className="text-lg font-semibold text-neutral-800 mb-2">Scan QR Code</h3>
            <p className="text-sm text-neutral-500">Scan to pay a merchant or friend</p>
          </button>

          <button
            onClick={() => navigate('/payment/receive')}
            className="card card-hover p-8 text-center group"
          >
            <div className="w-16 h-16 rounded-2xl bg-success-100 flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
              <ArrowDownIcon className="w-8 h-8 text-success-600" />
            </div>
            <h3 className="text-lg font-semibold text-neutral-800 mb-2">Receive Payment</h3>
            <p className="text-sm text-neutral-500">Share your QR code to get paid</p>
          </button>
        </div>
      </div>
    </NormalLayout>
  )
}

export default PayOrReceive
